import React, { Component } from 'react';

class LoginWithGoogle extends Component {
    state = {}
    render() {
        return (
            <div className='w-100 h-100'>
                {/* <button onClick={() => window.open('https://accounts.yonnect.com', '_blank', 'toolbar=no,height=450,width=450,directories=no')}> */}
                <button onClick={() => window.open('https://accounts.google.com', '_blank', 'toolbar=no,height=450,width=450,directories=no')}>
                    TEST WINDOW
                </button>
            </div>
        );
    }
}

export default LoginWithGoogle;